module.exports = __webpack_public_path__ + "img/heightmap.a8018022.png";